import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { NavLink, useNavigate } from "react-router";
import LoginStatus from "../auth/LoginStatus";
import { useAuth } from "@/contexts/AuthContext";
import NudgeAlert from "./NudgeAlert";

export default function Navbar({ showLoginStatus = true }) {
  const navigate = useNavigate();

  let isAuthenticated, user;

  try {
    ({ isAuthenticated, user } = useAuth());
  }
  catch (error) {
    console.error("Error in Navbar component: ", error);
    isAuthenticated = false;
    user = null;
  }

  return (
    <header className="p-4 m-4 border-b-2">
      <div className="flex justify-between items-center">
        {/* Left section: Branding + Navigation */}
        <div className="flex items-center space-x-6">
          <span className="text-2xl font-bold cursor-pointer" onClick={() => navigate("/")}>
            <FontAwesomeIcon className="pr-2" icon={faComments} /> ClarifAI
          </span>

          <nav className="flex space-x-4">
            <NavLink to="/" className="hover:underline">
              Projects
            </NavLink>
            {
              (isAuthenticated && user?.isProjectsAdmin) && (
              <NavLink to="/user-assignments" className="hover:underline">
                Users
              </NavLink>
              )
            }
            <NavLink to="/about" className="hover:underline">
              About
            </NavLink>
          </nav>
        </div>

        {/* Right section: Login Status */}
        {showLoginStatus && (
          <div className="flex items-center space-x-4">
            <NudgeAlert />
            <LoginStatus />
          </div>
        )}
      </div>
    </header>
  );
}
